import Typography from '@classify/react-core-components/Typography';
import { CircularLearningProgress } from '@openclassrooms/ui-web/progress';
import { makeStyles } from '@mui/styles';
import { translate } from '@openclassrooms/translations';

const useStyles = makeStyles(({ spacing }) => ({
  title: {
    marginBottom: spacing(1),
  },
  hStack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > * + *': {
      marginLeft: spacing(1),
    },
  },
}));

export interface CourseProgressProps {
  progression: number;
}
function CourseProgress({ progression }: CourseProgressProps) {
  const classes = useStyles();

  return (
    <>
      <Typography component="span" variant="overline" className={classes.title}>
        {translate('course.header.progress.label')}
      </Typography>

      <div className={classes.hStack}>
        <div>
          <CircularLearningProgress value={progression - 1} maxValue={100} ariaHidden="true" />
        </div>
        <Typography variant="h3" component="span">
          {progression}%
        </Typography>
      </div>
    </>
  );
}

export default CourseProgress;
